import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-update-license-server',
  templateUrl: './update-license-server.component.html',
  styleUrls: ['./update-license-server.component.scss']
})
export class UpdateLicenseServerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
